module.exports = __webpack_public_path__ + "img/qiehuan.b3c4cf5c.png";